<template>
  <div class="col-md-6">
    <h1>Acesso ao sistema</h1>

    <b-form @submit.prevent="login">
      <b-form-group label="CNPJ" label-for="input-companyDocument">
        <b-form-input
          type="text"
          id="input-companyDocument"
          placeholder="Informe o CNPJ da empresa"
          v-model="companyDocument"
          v-mask="'99.999.999/9999-99'"
        />
      </b-form-group>

      <b-form-group label="Nome de acesso" label-for="input-nomeAcesso">
        <b-form-input
          type="text"
          id="input-nomeAcesso"
          placeholder="Informe o nome de acesso"
          v-model="username"
        />
      </b-form-group>

      <b-form-group label="Senha de acesso" label-for="input-senhaAcesso">
        <b-form-input
          type="password"
          id="input-senhaAcesso"
          placeholder="Informe senha de acesso"
          v-model="password"
        />
      </b-form-group>

      <!-- submit button -->
      <div class="field has-text-right">
        <b-button type="submit" variant="primary">Entrar</b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
import AwesomeMask from "awesome-mask";

export default {
  data() {
    return {
      username: "",
      password: "",
      companyDocument: "",
    };
  },
  directives: {
    mask: AwesomeMask
  },
  methods: {
    login: function () {
      let companyDocument = this.companyDocument;
      let username = this.username;
      let password = this.password;
      this.$store
        .dispatch("login", { companyDocument, username, password })
        .then(() => this.$router.push("/"))
        .catch((err) => console.log(err));
    },
  },
};
</script>